export enum VerTypes {
    Web = "Web",
    Phone = "Phone",
}
